import axios from "axios";

let onSessionExpired = null;

// UserContext registers itself here once, at app start, so any axios call
// anywhere in the app (most API calls go through the shared axios module)
// can trigger a clean logout when the backend reports the token is no
// longer valid, instead of leaving the dashboard silently broken.
export const setSessionExpiredHandler = (handler) => {
  onSessionExpired = handler;
};

export const handleResponseError = (error) => {
  if (error.response?.status === 401 && onSessionExpired) {
    onSessionExpired();
  }
  return Promise.reject(error);
};

axios.interceptors.response.use((response) => response, handleResponseError);
